module.exports = __webpack_public_path__ + "img/PARON-CARD.003e8d0b.jpg";